export default __webpack_public_path__ + "static/media/rf_bjt.a8341fdd.svg";